<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId"
      :validated="formObserver.validated && observer.failed"
      v-bind="observer"
      :no-validity="hasNoValidity"
      :is-loading="isLoading"
    >
      <form-row
        :label="isAdditional ? titleAdditional || title : title"
        :question="isAdditional ? subtitleAdditional || subtitle : subtitle"
        :error="formObserver.validated && observer.failed"
      >
        <template
          v-if="helpText && !helpText.fullWidth"
          #helpText
        >
          <help-text-content
            :help-text="helpText"
            :is-additional="isAdditional"
          />
        </template>
        <slot />
      </form-row>
      <slot
        name="subsection"
        :observer="observer"
      />

      <help-text-controller
        v-if="helpText && helpText.fullWidth"
        :help-text="helpText"
        :error="formObserver.validated && observer.failed"
      />
      <slot
        name="footer"
        :observer="observer"
      />
    </form-section>
  </validation-observer>
</template>

<script>
export default {
  name: 'question-base-wrapper',
  props: {
    shouldQuestionRender: {
      type: Boolean,
      required: true,
    },
    isRenderAfterFullfilled: {
      type: Boolean,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    isAdditional: {
      type: Boolean,
      required: true,
    },
    helpText: {
      default: null,
      validator: value => ['string', 'object'].includes(typeof value) || value === false,
    },
    validationRules: {
      type: Object,
      default: null,
    },
    questionId: {
      type: String,
      default: null,
    },
    titleAdditional: {
      type: String,
      default: null,
    },
    subtitleAdditional: {
      type: String,
      default: null,
    },
    subtitle: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
    title: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasNoValidity () {
      return this.validationRules && Object.keys(this.validationRules).some(key => this.validationRules[key].required === false);
    },
  },
};
</script>
